import { useState } from "react";
import "./styles/app.css";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import SessionDetail from "./pages/SessionDetail";
import Cookies from "./pages/Cookies";
import Messages from "./pages/Messages";
import { getToken } from "./api/client";

export default function App() {
  const [authed, setAuthed] = useState(!!getToken());
  const [sessionId, setSessionId] = useState(null);
  const [page, setPage] = useState("dashboard"); // dashboard | cookies | messages

  if (!authed) return <Login onLoggedIn={() => setAuthed(true)} />;

  // Session seçildiyse detay öncelikli
  if (sessionId)
    return (
      <SessionDetail
        sessionId={sessionId}
        onBack={() => setSessionId(null)}
      />
    );

  // Sayfa switch
  if (page === "cookies")
    return (
      <Cookies
        onNavigate={setPage}
        onLogout={() => setAuthed(false)}
      />
    );

  if (page === "messages")
    return (
      <Messages
        onNavigate={setPage}
        onLogout={() => setAuthed(false)}
      />
    );

  return (
    <Dashboard
      onSelectSession={setSessionId}
      onLogout={() => setAuthed(false)}
      onNavigate={setPage}
      page={page}
    />
  );
}
